var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-list-group',{attrs:{"flush":""}},_vm._l((_vm.data),function(record){return _c('b-list-group-item',{key:record.id,staticClass:"p-1"},[_c('DefList',{attrs:{"data":record.fields,"size":"small"}})],1)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }